module.exports = __webpack_public_path__ + "img/hongkong.3376ddf1.png";